// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=3228-31672
// Component: SelectedPayment
// Shows the selected payment method with icon, title, subtitle, price and optional voucher pills
// States: normal | disabled (opacity-38)
// Variants: fixed price (shows price + ⓘ) | taximeter (no price)

import classnames from 'classnames'
import SummaryIcon from '~/components/ui/SummaryIcon'
import Spinner from '~/components/ui/Spinner'
import { Pill } from '~/components'

function InfoIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
      <circle cx="8" cy="8" r="7.25" stroke="#17181A" strokeWidth="1.5"/>
      <path d="M8 7v5" stroke="#17181A" strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="8" cy="4.5" r="1" fill="#17181A"/>
    </svg>
  )
}

export default function SelectedPayment({ icon, title, subtitle, priceLabel, price, priceLoading, voucherPills, onInfo, disabled }) {
  const isFixedPrice = Boolean(price)
  const hasReducedPrice = isFixedPrice && price.finalPrice !== price.fullPrice
  const showPriceArea = isFixedPrice || priceLoading

  return (
    <div className={classnames('flex flex-col w-full py-3', disabled && 'opacity-[0.38]')}>
      {/* Info button — only for fixed price */}
      {isFixedPrice && (
        <div className="flex justify-end mb-0.5">
          {onInfo
            ? <button type="button" onClick={onInfo} className="p-0.5 -mr-0.5" aria-label="Prisinformation"><InfoIcon /></button>
            : <InfoIcon />
          }
        </div>
      )}

      {/* Main row */}
      <div className="flex gap-3 items-center w-full">
        {/* Payment icon */}
        <div className="shrink-0 size-11 flex items-center justify-center">
          <SummaryIcon id={icon} />
        </div>

        {/* Text */}
        <div className="flex-1 flex flex-col items-start min-w-0">
          <span className="text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface">{title}</span>
          {subtitle && (
            <span className="text-[15px] leading-5 text-on-surface-variant">{subtitle}</span>
          )}
          {priceLabel && (
            <span className="text-[15px] leading-5 text-on-surface-variant">{priceLabel}</span>
          )}
          {voucherPills?.length > 0 && (
            <div className="flex gap-1 flex-wrap mt-0.5">
              {voucherPills.map((text, i) => <Pill key={i} text={text} type="user-choice" />)}
            </div>
          )}
        </div>

        {/* Price or spinner — only for fixed price context */}
        {showPriceArea && (
          <div className="shrink-0 flex flex-col items-end">
            {priceLoading ? (
              <Spinner size={18} />
            ) : (
              <>
                <span className="text-[17px] font-semibold tracking-[0.68px] uppercase leading-5 text-on-surface">
                  {price.finalPrice}:-
                </span>
                {hasReducedPrice && (
                  <span className="text-[15px] leading-5 text-on-surface-variant line-through">
                    {price.fullPrice}:-
                  </span>
                )}
              </>
            )}
          </div>
        )}
      </div>
    </div>
  )
}
